import { removeInIndex } from '@weft/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TrashIcon } from '../../../../../components/icons/TrashIcon';
import { useScrollIntoViewOnMount } from '../../../../../hooks/use-scroll-to';
import type { PlanInputForm } from '../CreatePlanForm/create-plan-form-types/plan-input-form';
import { PlanChargesContainer } from '../PlanChargesContainer';
import { PromotionCardHeaderEdit } from './PromotionCardHeaderEdit';

export type PromotionChargeEditProps = {
  promotionIndex: number;
};

export const PromotionChargeEdit: React.FC<PromotionChargeEditProps> = ({ promotionIndex }) => {
  const { setValue, getValues } = useFormContext<PlanInputForm>();

  useScrollIntoViewOnMount(`create-promotion-${promotionIndex}`);

  const onDeleteClicked = () => {
    const updatedPromotions = removeInIndex(getValues('promotions') ?? [], promotionIndex);
    setValue('promotions', updatedPromotions);
  };
  
  return (
    <PlanChargesContainer
      key={promotionIndex}
      className="pt-6"
      id={`create-promotion-${promotionIndex}`}
    >
      <div className='divide-line space-y-8 divide-y'>
        <div>
          <PromotionCardHeaderEdit
            promotionIndex={promotionIndex}
          />

          <div className="space-x-5.5 flex justify-end pb-3.5 pt-4">
            <TrashIcon
              className='fill-icon'
              onClick={onDeleteClicked}
            />
          </div>
        </div>
      </div>
    </PlanChargesContainer>
  );
};